// SVG ICON : CalendarIco
import React from 'react'

type Props = {
  color?: string
  className?: string
}

class ArrowLeft extends React.Component<Props> {
  render() {
    const { color, className } = this.props

    return (
      <svg
        width='8'
        height='14'
        viewBox='0 0 8 14'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
      >
        <path
          d='M7.16016 0.654297L1.20681 6.60765L7.16016 12.561'
          stroke={color || '#ffffff'}
          strokeWidth='1.13397'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    )
  }
}

export default ArrowLeft
